export const resolveGameImageUrl = (image?: string | null) => {
    if (!image) return undefined;

    const imageBaseUrl =
        process.env.NODE_ENV === "development" &&
        process.env.REACT_APP_IMAGES_BASE_URL
            ? process.env.REACT_APP_IMAGES_BASE_URL
            : window.location.origin;

    try {
        return new URL(image, imageBaseUrl).toString();
    } catch (e) {
        return image;
    }
};

export const getGameConfigurationImagePath = (
    configurationId: number,
    image?: string | null
) => {
    if (!image) return undefined;

    const imageName = image.split(/[\\/]/).pop();
    if (!imageName) return undefined;

    return `/wave/games/config/${configurationId}/image/${encodeURIComponent(
        imageName
    )}`;
};
